import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../../models/products.model';  // Importamos la interfaz Product
import { environment } from '../../../environments/environment';  // Importamos el entorno
import { AuthService } from '../auth/auth.service';
import { format } from 'date-fns-tz';

@Injectable({
  providedIn: 'root'
})
export class OrderServiceService {
  private apiUrl = environment.apiUrl;  // Usamos la URL del entorno
  private routerApi = 'api/orders';  // Usamos la URL de la API de productos
  constructor(private http: HttpClient, private authService: AuthService) { }
  
  getOrders(page: string, filters?: { nombreProducto?: string; idProvaider?: string }): Observable<any> {
    let params: any = {};
    if (filters?.nombreProducto) params.nombreProducto = filters.nombreProducto;
    if (filters?.idProvaider) params.idProvaider = filters.idProvaider;
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/${page}`, { params });
  }
  getOrderById(user: string, id: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${user}`,
    });
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/orderID/${id}`, {headers});
  }
  getOrderDetails(user: string, id: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${user}`,
    });
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/order_details/${id}`, {headers});
  }
  //Este endpoint también recibe id de usuario para retornar los pedidos del usuario actual
  getOrdersByStatus(user: string, status: string, page: string = '1', itemsPerPage: number = 10): Observable<any> {
    let params = new HttpParams();
    params = params.set('page', page);
    params = params.set('limit', itemsPerPage);
    const headers = new HttpHeaders({
      Authorization: user,
    });
    return this.http.get<any>(`${this.apiUrl}/${this.routerApi}/orderByStatus/${status}`,
      { headers, params },
    );
  }
  placeOrder(orderData: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${this.routerApi}`, orderData);
  }
  generateRaring(dataRating: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${this.routerApi}/rate_product`, dataRating);
  }
  rateProduct(productId: string, orderId: string, rating: number): Observable<any>{
    return this.http.patch<any>(
      `${this.apiUrl}/${this.routerApi}/rate_product`,
      { orderId, productId, rating }
    );
  }
  getTransaction(id: any) {
    let params = new HttpParams();
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.apiUrl}/api/paymentMethod/${id}`, {params})
        .subscribe({
          next: (response: any) => {
            resolve(response.data);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
  formatDate(date: Date) {
   
    const formattedDate = date;

    return formattedDate;
  }
}


